import { INotifyEnum, notify } from "@/utils/toaster";
import { addToCartApi } from "@/utils/apis/patient/tests";

import { useAppSelector } from "@/store/hooks";

import useGetCartDetails from "./useGetCartDetails";

const useClearCart = () => {
  const { getCartDetails } = useGetCartDetails();

  const diagnosticTestList = useAppSelector((state) => state.tests);
  const { cartDetails, centreDetails } = diagnosticTestList;
  const cartList = cartDetails?.diagnosticTestIds;

  const onClearCart = async () => {
    try {
      const clearCartRes = await addToCartApi({
        diagnosticId: cartDetails?.diagnosticId,
        diagnosticTestIds: cartList,
        bookingTimestamp: cartDetails?.bookingTimestamp,
        action: "CLEAR",
      });
      if ("result" in clearCartRes) {
        notify(INotifyEnum.SUCCESS, clearCartRes?.message);
        getCartDetails();
      } else {
        notify(INotifyEnum.ERROR, clearCartRes?.message);
      }
    } catch (error) {
      notify(INotifyEnum.ERROR, error?.message);
    }
  };

  const onCartFun = async (testId: string, action: string) => {
    const currentCart = cartDetails?.diagnosticTestIds || [];
    const updatedCart = currentCart.includes(testId)
      ? currentCart.filter((id) => id !== testId)
      : [...currentCart, testId];
    try {
      const addToCartResponse = await addToCartApi({
        diagnosticId: centreDetails?.user_id || cartDetails?.diagnosticId,
        diagnosticTestIds: updatedCart,
        bookingTimestamp:
          parseInt(centreDetails?.selectedDate) ||
          cartDetails?.bookingTimestamp,
        action: action,
      });

      if ("result" in addToCartResponse) {
        getCartDetails();
      } else {
        notify(INotifyEnum.ERROR, addToCartResponse?.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // getCartDetails is already called via useGetCartDetails so no extra effect is needed here

  return { onClearCart, onCartFun };
};

export default useClearCart;
